import React, { Component, Suspense } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider
} from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import moment from 'moment';
import { defaultTheme } from '../../utils/mui-themes';
import { navLang } from '../../utils/date';

const BookingsAISignUp = React.lazy(() =>
  import('./bookings-ai/index')
);
const GenerativeAISignUp = React.lazy(() =>
  import('./generative-ai/index')
);

const theme = createTheme(defaultTheme);
class SignUpApp extends Component {
  componentDidMount() {
    if (navLang) {
      moment.locale(navLang);
    }
  }
  render() {
    const isBookingsAISignUp = this.props.location.pathname.indexOf('/bookings-ai-sign-up') === 0;
    const isBrandedSignUp = isBookingsAISignUp || [
      '/generative-ai-sign-up/emailAssist',
      '/generative-ai-sign-up/itineraryAssist',
    ].includes(this.props.location.pathname);
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <React.Fragment>
            <CssBaseline />
            <div
              style={{
                backgroundColor: isBrandedSignUp ? '#fff' : '#efefef',
                width: '100%',
                margin: 'auto',
                padding: isBrandedSignUp ? 0 : '5em 0',
                minHeight: '100vh',
                height: isBrandedSignUp ? 'auto' : '100vh',
                fontFamily:
                  "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif"
              }}
            >
              <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                  <Route
                    path="/bookings-ai-sign-up"
                    component={BookingsAISignUp}
                  />
                  <Route
                    path="/generative-ai-sign-up/:genAiProduct"
                    component={GenerativeAISignUp}
                  />
                </Switch>
              </Suspense>
            </div>
          </React.Fragment>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

const mapActions = {};

const mapState = ({ account: { accountLoaded } }) => ({
  accountLoaded
});

export default hot(module)(withRouter(connect(mapState, mapActions)(SignUpApp)));
